<template>
  <div class="container">
    <div class="stock-dashboard_header">
      <h3>{{ i18n.t('/StockDashboard/Title') }}</h3>
      <!--
        TODO CST-2982
        replace download-stock-button with a new button or maybe the same button,
        but then adds a extra parameter, so the PCQM backend knows to fetch the
        data from another VIEW; This view should be based on the new stock table.
       -->
      <download-stock-button />
    </div>

    <div class="filter-dashboard">
      <div class="search-wrapper">
        <stock-dashboard-search v-model="searchQuery" @on-search="onSearch" />
      </div>
      <stock-dashboard-reservation-new
        v-model="reservationStatuses"
        class="reservation"
        @on-update-reservation-status="onChangeReservationStatus"
      />
      <form-checkbox id="national-stock" :title="i18n.t('/StockDashboard/ShowNationalStock')">
        <input
          id="national-stock"
          v-model="showNationalStock"
          data-qa="national-stock-checkbox"
          type="checkbox"
          name="national-stock"
          @change="onChangeShowNationalStock"
        />
      </form-checkbox>
    </div>

    <stock-dashboard-table-new
      :reservation-statuses="reservationStatuses"
      @select-stock-car-new="selectStockCarNew"
    />

    <div class="loader-wrapper">
      <loader v-if="isLoading" />
    </div>

    <app-button v-if="!endReached" data-qa="show-more-stock-cars-button" @click="loadMore">
      {{ i18n.t('/StockDashboard/Table/LoadMore') }}
    </app-button>

    <stock-car-detail-new
      v-if="selectedStockCar"
      :stock-car="selectedStockCar"
      @on-error="selectStockCarNew(null)"
      @on-cancel="selectStockCarNew(null)"
      @close="selectStockCarNew(null)"
    />
  </div>
</template>
<script>
import DownloadStockButton from '@/components/generic/presentational/molecules/downloadButton/DownloadStockButton.vue'
import StockDashboardSearch from '@/components/generic/presentational/organisms/stockDashboard/StockDashboardSearch.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import stockCarsServiceNew from '@/services/StockCarsServiceNew'
import StockDashboardTableNew from '@/components/generic/presentational/organisms/stockDashboardNew/StockDashboardTableNew.vue'
import StoreConnector from '@/helpers/StoreConnector'
import ReservationStatusNew from '@/helpers/enums/reservationStatusNew'
import StockDashboardReservationNew from '@/components/generic/presentational/organisms/stockDashboardNew/StockDashboardReservationNew.vue'
import FormCheckbox from '@/components/generic/presentational/atoms/formCheckbox/FormCheckbox.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import StockCarDetailNew from '@/components/generic/presentational/organisms/stockDashboardNew/stockCarDetail/StockCarDetailNew.vue'

export default {
  components: {
    StockCarDetailNew,
    AppButton,
    FormCheckbox,
    StockDashboardReservationNew,
    StockDashboardTableNew,
    Loader,
    StockDashboardSearch,
    DownloadStockButton,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isLoading: false,
      selectedStockCar: null,
      searchQuery: '',
      currentPage: 1,
      pageSize: 5,
      stockCars: [],
      reservationStatuses: [ReservationStatusNew.AVAILABLE.value],
      showNationalStock: false,
      endReached: false,
    }
  },
  created() {
    this._fetchGeneration = 0
    if (this.$route.query.search) {
      // external applications use this for searching directly
      this.searchQuery = this.$route.query.search
    }
    this.fetchStockcars()
    StoreConnector.get('stockcarsNew/isLoading', (data) => {
      this.isLoading = data
    })
  },
  methods: {
    selectStockCarNew(selectedStockCar) {
      this.selectedStockCar = selectedStockCar
    },
    async onSearch(query) {
      this.searchQuery = query
      this.currentPage = 1
      await this.fetchStockcars()
    },
    async onChangeShowNationalStock() {
      this.currentPage = 1
      await this.fetchStockcars()
    },
    async onChangeReservationStatus(reservationStatuses) {
      this.reservationStatuses = reservationStatuses
      this.currentPage = 1
      await this.fetchStockcars()
    },
    async loadMore() {
      this.currentPage++
      await this.fetchStockcars()
    },
    async fetchStockcars() {
      // Increment the generation so any in-flight fetch from a previous call
      // can detect it has been superseded and discard its results.
      const generation = ++this._fetchGeneration

      this.isLoading = true
      const search = this.searchQuery
      const status = this.reservationStatuses
      const size = this.pageSize
      const page = this.currentPage
      const includeNationWide = this.showNationalStock
      this.endReached = false

      if (this.currentPage === 1) {
        await stockCarsServiceNew.resetStockCars()
      }

      const length = await stockCarsServiceNew.getStockCars(
        page,
        size,
        search,
        status,
        includeNationWide
      )

      // A newer fetch was triggered while we were waiting — ignore our results.
      if (generation !== this._fetchGeneration) return

      if (length < size) this.endReached = true

      this.isLoading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.container {
  @include center;
}

.filter-dashboard {
  display: grid;
  grid-auto-flow: column;
  -moz-column-gap: 1em;
  column-gap: 1em;
  align-items: center;
}

.reservation,
.search-wrapper {
  margin-right: 1em;
}

.search-wrapper {
  flex: 1 0 auto;
}

.loaderWrapper {
  display: grid;
}

.stock-dashboard_header {
  display: flex;
  justify-content: space-between;
}
</style>
